import React from "react";
import "./LoginPage.css";
import { OAUTH_PROVIDERS } from "../../auth/providers";
import useMobileDetect from "../../hooks/useMobileDetect";

const LoginPage = () => {
  const isMobile = useMobileDetect(1024);

  if (isMobile === null) {
    return null;
  }

  const handleOAuthRedirect = async (authUrl: string) => {
    window.location.href = authUrl;
  };

  const LoginCard = () => (
    <div className="login-card">
      <div className="seconds-login-card">
        <div className="login-header">
          <img src="/images/Helen-two.svg" className="logo-right-section" />
        </div>
        <h2 className="login-title">Login / Signup to your Account</h2>
        <p className="login-subtitle">One step away from creating magic</p>
        {OAUTH_PROVIDERS.filter((p) => p.enabled).map((provider) => (
          <div className={`${provider.id}-login-container`} key={provider.id}>
            <button
              className={`${provider.id}-login`}
              onClick={() => handleOAuthRedirect(provider.authUrl)}
              style={{ display: "flex", alignItems: "center", margin: "8px" }}
            >
              <img
                src={provider.icon}
                alt={provider.name}
                width={24}
                height={24}
                style={{ marginRight: 8 }}
              />
              {provider.buttonText}
            </button>
          </div>
        ))}
      </div>
    </div>
  );

  // Mobile View
  if (isMobile) {
    return (
      <div className="login-container mobile-container">
        <div className="left-section">
          <img
            src="/images/shape-bg.svg"
            alt="Background Shape"
            className="background-image"
          />
          <LoginCard />
        </div>
      </div>
    );
  }

  // Desktop View
  return (
    <div className="login-container">
      <div className="left-section">
        <img
          src="/images/shape-bg.svg"
          alt="Background Shape"
          className="background-image"
        />
        <div className="logo-container">
          <img src="/images/Helens.svg" alt="Helen Logo" className="logo" />
        </div>
      </div>
      <div className="right-section">
        <LoginCard />
      </div>
    </div>
  );
};

export default LoginPage;
